// extracted by mini-css-extract-plugin
export var carrierTab = "_5g-0";
export var carrierTabActive = "_5g-1 _5g-0";
export var carrierTabInactive = "_5g-2 _5g-0";
export var carrierTabLabel = "_5g-3";
export var carrierTabLabelActive = "_5g-4 _5g-3";
export var carrierTabLabelInactive = "_5g-5 _5g-3";
export var carrierTabPercentage = "_5g-6";
export var carrierTabPercentageActive = "_5g-7 _5g-6";
export var carrierTabPercentageInactive = "_5g-8 _5g-6";
export var carrierTabWinnable = "_5g-9";
export var carrierTabWinnableActive = "_5g-a _5g-9";
export var carrierTabWinnableInactive = "_5g-b _5g-9";
export var comparisonContainer = "_5g-d";
export var missingRateButton = "_5g-n";
export var missingRateButtonActive = "_5g-o _5g-n";
export var missingRateButtonInactive = "_5g-p _5g-n";
export var missingRateButtonLabel = "_5g-q";
export var missingRateButtonLabelActive = "_5g-r _5g-q";
export var missingRateButtonLabelInactive = "_5g-s _5g-q";
export var sidebar = "_5g-c";
export var strategyButton = "_5g-e";
export var strategyButtonActive = "_5g-f _5g-e";
export var strategyButtonDescription = "_5g-k";
export var strategyButtonDescriptionActive = "_5g-l _5g-k";
export var strategyButtonDescriptionInactive = "_5g-m _5g-k";
export var strategyButtonInactive = "_5g-g _5g-e";
export var strategyButtonLabel = "_5g-h";
export var strategyButtonLabelActive = "_5g-i _5g-h";
export var strategyButtonLabelInactive = "_5g-j _5g-h";
export var unitToggleButton = "_5g-t";
export var unitToggleButtonActive = "_5g-u _5g-t";
export var unitToggleButtonInactive = "_5g-v _5g-t";
export var unitToggleButtonLabel = "_5g-w";
export var unitToggleButtonLabelActive = "_5g-x _5g-w";
export var unitToggleButtonLabelInactive = "_5g-y _5g-w";